/**
 * @generated SignedSource<<59d32251ba1294e67e4a936d8cf06b9b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type BookingStatus = "CONFIRMED" | "DRAFT";
export type BookingWriteAccess = "FULL_WRITE" | "JOIN" | "NONE" | "NON_OWNER_WRITE";
export type SlotAvailability = "ACCESSIBLE" | "ACCESSIBLE_BOOKING" | "AVAILABLE" | "AVAILABLE_AFTER_START" | "BLOCKED" | "BLOCKED_BY_BLOCK" | "BLOCKED_BY_BOOKING" | "BLOCKED_BY_EVENT" | "FREE" | "UNAVAILABLE";
import { FragmentRefs } from "relay-runtime";
export type TimeSlotRow_Timeslot$data = {
  readonly agenda: {
    readonly date: string;
  };
  readonly availability: SlotAvailability;
  readonly block: {
    readonly id: string;
  } | null | undefined;
  readonly bookings: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly canUpdate: boolean | null | undefined;
        readonly id: string;
        readonly ownerClient: {
          readonly __typename: "Customer";
          readonly id: string;
        } | {
          readonly __typename: "Member";
          readonly id: string;
        } | {
          // This will never be '%other', but we need some
          // value in case none of the concrete values match.
          readonly __typename: "%other";
        } | null | undefined;
        readonly rounds: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly player: {
                readonly id: string;
              } | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly status?: BookingStatus;
        readonly writeAccess: BookingWriteAccess | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly capacity: number;
  readonly course: {
    readonly id: string;
    readonly name: string;
  };
  readonly dateTime: string | null | undefined;
  readonly groupLabel: string | null | undefined;
  readonly holeOffset: number;
  readonly id: string;
  readonly time: string;
  readonly usedCapacity: number;
  readonly " $fragmentSpreads": FragmentRefs<"PrivateTimeSlotCardWrapper_timeSlot" | "PublicTimeSlotCardWrapper_Timeslot">;
  readonly " $fragmentType": "TimeSlotRow_Timeslot";
};
export type TimeSlotRow_Timeslot$key = {
  readonly " $data"?: TimeSlotRow_Timeslot$data;
  readonly " $fragmentSpreads": FragmentRefs<"TimeSlotRow_Timeslot">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
],
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isCustomer"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "membershipTypeId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TimeSlotRow_Timeslot",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "time",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dateTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Agenda",
      "kind": "LinkedField",
      "name": "agenda",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "date",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "availability",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "holeOffset",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "groupLabel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "bookingType",
          "value": "STANDARD"
        }
      ],
      "kind": "ScalarField",
      "name": "capacity",
      "storageKey": "capacity(bookingType:\"STANDARD\")"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "usedCapacity",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TimeSlotBlock",
      "kind": "LinkedField",
      "name": "block",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "condition": "isCustomer",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "membershipTypeId",
              "variableName": "membershipTypeId"
            }
          ],
          "kind": "FragmentSpread",
          "name": "PublicTimeSlotCardWrapper_Timeslot"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PrivateTimeSlotCardWrapper_timeSlot"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Course",
      "kind": "LinkedField",
      "name": "course",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BookingConnection",
      "kind": "LinkedField",
      "name": "bookings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "BookingEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "canUpdate",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "writeAccess",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "ownerClient",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v1/*: any*/),
                      "type": "Member",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": (v1/*: any*/),
                      "type": "Customer",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v2/*: any*/),
                  "type": "StandardBooking",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v2/*: any*/),
                  "type": "DiningBooking",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": (v2/*: any*/),
                  "type": "LessonBooking",
                  "abstractKey": null
                },
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "noShowStatus",
                      "value": [
                        "PRESENT"
                      ]
                    }
                  ],
                  "concreteType": "RoundConnection",
                  "kind": "LinkedField",
                  "name": "rounds",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "RoundEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": null,
                              "kind": "LinkedField",
                              "name": "player",
                              "plural": false,
                              "selections": (v1/*: any*/),
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": "rounds(noShowStatus:[\"PRESENT\"])"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TimeSlot",
  "abstractKey": null
};
})();

(node as any).hash = "10c0b1352434c8b3106474daef070c6f";

export default node;
